export const VEHICLES_FILTERS_FORM = 'vehiclesFiltersForm';
